import { RouterModule, Routes } from '@angular/router'
import { NgModule } from '@angular/core'
import { OrdersDashboardComponent } from './orders-dashboard/orders-dashboard.component'

const ordersRoutes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'dashboard',
  },
  {
    path: 'dashboard',
    component: OrdersDashboardComponent,
  },
]

@NgModule({
  imports: [RouterModule.forChild(ordersRoutes)],
  exports: [RouterModule],
})
export class OrdersRoutingModule {}
